import React, { useState } from 'react';
import {
  FindManyUserSceneAssetsDocument,
  useUpdateUserSceneAssetsMutation,
} from '@src/components/generated/graphql';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import DefaultButton from '@src/components/ui-kit/buttons/DefaultButton';
import ecmrceStyles from '../../asset-store/created-assets/created-assets.module.css';

const EcommerceElementShopify = ({ el }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [updateAsset] = useUpdateUserSceneAssetsMutation();

  const setEnablePurchase = async (id, value: boolean) => {
    setIsLoading(true);
    await updateAsset({
      variables: {
        where: {
          id,
        },
        data: {
          enablePurchase: {
            set: value,
          },
        },
      },
      refetchQueries: [FindManyUserSceneAssetsDocument],
    });
    setIsLoading(false);
  };

  return (
    <div key={el.id} className={ecmrceStyles.card}>
      <div className={ecmrceStyles.info}>
        <div className={ecmrceStyles.name}>{el.name}</div>
      </div>
      {el.enablePurchase ? (
        <DefaultButton
          style={{ width: 180 }}
          type='secondary'
          onClick={() => setEnablePurchase(el.id, false)}
        >
          {isLoading ? (
            <Spin indicator={<LoadingOutlined />} spinning />
          ) : (
            <span>Disable purchase</span>
          )}
        </DefaultButton>
      ) : (
        <DefaultButton
          style={{ width: 180 }}
          type='primary'
          onClick={() => setEnablePurchase(el.id, true)}
        >
          {isLoading ? (
            <Spin indicator={<LoadingOutlined />} spinning />
          ) : (
            <span style={{ color: '#fff' }}>Enable purchase</span>
          )}
        </DefaultButton>
      )}
    </div>
  );
};

export default EcommerceElementShopify;
